import React from 'react'
import { StatCards } from '@/shared/ui'
import type { CustomerStats } from '../types'
import { CheckCircle, Clock, AlertTriangle, UserX } from 'lucide-react'

type Props = {
  stats: CustomerStats
  className?: string
}

export default function CustomerStatsCards({ stats, className }: Props) {
  const items = React.useMemo(() => [
    { label: 'Ativos', value: (stats?.ativo || 0).toLocaleString('pt-BR'), icon: <CheckCircle className="h-5 w-5" />, tone: 'success' as const },
    { label: 'Pendentes', value: (stats?.pendente || 0).toLocaleString('pt-BR'), icon: <Clock className="h-5 w-5" />, tone: 'primary' as const },
    { label: 'Suspensos', value: (stats?.suspenso || 0).toLocaleString('pt-BR'), icon: <AlertTriangle className="h-5 w-5" />, tone: 'warning' as const },
    { label: 'Inativos', value: (stats?.inativo || 0).toLocaleString('pt-BR'), icon: <UserX className="h-5 w-5" />, tone: 'violet' as const },
  ], [stats])
  return <StatCards items={items} className={className} />
}

